// mealsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  byId: {},
  allIds: [],
};

const mealsSlice = createSlice({
  name: "meals",
  initialState,
  reducers: {
    setMeals(state, action) {
      state.byId = {};
      state.allIds = [];
      action.payload.forEach(meal => {
        state.byId[meal.id] = meal;
        if (!state.allIds.includes(meal.id)) state.allIds.push(meal.id);
      });
    },
    addFoodToMeal(state, action) {
      const { mealId, foodId } = action.payload;
      const meal = state.byId[mealId];
      if (!meal) return;
      if (!meal.foodPortions) meal.foodPortions = {};
      if (!meal.foodPortions[foodId]) meal.foodPortions[foodId] = 100;
    },
    removeFoodFromMeal(state, action) {
      const { mealId, foodId } = action.payload;
      const meal = state.byId[mealId];
      if (meal.foodPortions && meal.foodPortions[foodId]) {
        delete meal.foodPortions[foodId];
      }
    },
    addMeal(state, action) {
      const meal = action.payload;
      state.byId[meal.id] = { mealType: "lunch", foodPortions: {}, ...meal };
      if (!state.allIds.includes(meal.id)) state.allIds.push(meal.id);
    },
    updateMeal(state, action) {
      const meal = action.payload;
      state.byId[meal.id] = meal;
    },
    deleteMeal(state, action) {
      const id = action.payload;
      delete state.byId[id];
      state.allIds = state.allIds.filter(i => i !== id);
    },
  },
  // ✅ NEW
  extraReducers: (builder) => {
    builder.addCase("app/rehydrate", (state, action) => {
      const meals = action.payload?.meals;
      if (meals?.length) {
        state.byId = {};
        state.allIds = [];
        meals.forEach(meal => {
          state.byId[meal.id] = meal;
          if (!state.allIds.includes(meal.id)) state.allIds.push(meal.id);
        });
      }
    });
  },
});

export const { setMeals, addFoodToMeal, removeFoodFromMeal, addMeal, updateMeal, deleteMeal } =
  mealsSlice.actions;

export default mealsSlice.reducer;